import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import { avatar, icon } from './ui';
import Link from 'flarum/common/components/Link';
export default class CommunityPanel extends Component {
  users = [];
  loading = true;
  oninit(vnode) {
    super.oninit(vnode);
    this.loadUsers();
  }
  async loadUsers() {
    try {
      const users = await app.store.find('users', {
        page: {
          limit: 7
        },
        sort: '-lastSeenAt'
      });
      this.users = (Array.isArray(users) ? users : []).filter(user => user !== app.session.user).slice(0, 6);
    } catch {
      this.users = app.store.all('users').filter(user => user !== app.session.user).slice(0, 6);
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  view() {
    const discordUrl = app.forum.attribute('novatruckDiscordUrl') || '#';
    const discordMembers = app.forum.attribute('novatruckDiscordMembers') || '2350';
    const online = this.users;
    return m('[', null, m("a", {
      className: "NtCard NtDiscord",
      href: discordUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, m("span", {
      className: "NtDiscord-icon"
    }, icon('fab fa-discord')), m("span", null, m("strong", null, "Discord"), m("small", null, "Do\u0142\u0105cz do naszej spo\u0142eczno\u015Bci", m("br", null), "ponad ", discordMembers, " cz\u0142onk\xF3w")), icon('fas fa-chevron-right')), m("section", {
      className: "NtCard NtOnline"
    }, m("div", {
      className: "NtCard-title"
    }, "Ostatnio online"), m("div", {
      className: "NtOnline-list"
    }, online.length ? online.map(user => m(Link, {
      href: `/u/${encodeURIComponent(user.slug?.() || user.username())}`,
      title: user.displayName?.() || user.username()
    }, avatar(user))) : m("span", {
      className: "NtOnline-empty"
    }, this.loading ? 'Pobieranie aktywnych graczy…' : 'Brak ostatnio aktywnych graczy'))));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/CommunityPanel', CommunityPanel);